import { memo, useEffect } from 'react'

import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import styles from './index.module.scss'
import { PageAlias } from '@/utils/pageRouter'
import uuidUtil from '@/utils/uuid'
import cacheUtil, { CACHE_WORKSPACE_KEY } from '@/utils/cache'
import Qs from 'query-string'
import LayoutHeader from './components/Header'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@/store/types'
import { getUserInfo, getWorkspaceMember, getUserRelations, getWorkspaceInfo } from '@/store/user'
import MySider from './components/Sider'

const Layout = memo(() => {
  const { t } = useTranslation()
  const navigation = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  let location = useLocation()
  const noAuth: string[] = [`/${PageAlias.login}`, `/${PageAlias.home}`]
  const uuid = uuidUtil.getUUID()
  const inWallet = cacheUtil.get(CACHE_WORKSPACE_KEY)
  useEffect(() => {
    if (!uuid) {
      if (location.pathname !== `/${PageAlias.login}`) {
        navigation('/login')
      }
    } else if (location.pathname === `/${PageAlias.login}`) {
      navigation('/home')
    } else if (location.pathname !== `/${PageAlias.home}` && !inWallet) {
      navigation('/home')
    }
  }, [uuid, location.pathname, inWallet])
  const checkWorkspaceKey = () => {
    const { search } = window.location
    const parsed = Qs.parse(search)
    if (parsed.wkey) {
      cacheUtil.set(CACHE_WORKSPACE_KEY, parsed.wkey)
    }
  }
  const WorkspaceInit = () => {
    console.log('init')
    checkWorkspaceKey()
    if (uuidUtil.getUUID()) {
      dispatch(getUserRelations())
      dispatch(getUserInfo())
      if (cacheUtil.get(CACHE_WORKSPACE_KEY)) {
        dispatch(getWorkspaceMember())
        dispatch(getWorkspaceInfo())
      }
    }
  }
  useEffect(() => {
    document.title = `${t('pageTitle')}`
    WorkspaceInit()
  }, [uuid, inWallet])

  if (noAuth.includes(location.pathname)) {
    return (
      <div className={styles.container}>
        <LayoutHeader />
        <Outlet />
      </div>
    )
  }

  if (uuid && inWallet) {
    return (
      <div className={styles.container}>
        <LayoutHeader />
        <div className={styles.bodyer}>
          <MySider />
          <div className={styles.content}>
            <Outlet />
          </div>
        </div>
      </div>
    )
  }

  return null
})

export default Layout
